var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.8094 31.6555C47.6045 28.3661 48.5615 24.5555 48.3939 20.5064C47.9461 9.65708 39.1972 0.711661 28.36 0.042252C15.9176 -0.72577 5.58594 9.13754 5.58594 21.4142C5.58594 25.1244 6.53094 28.6129 8.19006 31.6555H8.18911L8.1928 31.6592C9.05311 33.2354 10.1061 34.6897 11.3202 35.9931C13.7297 38.5795 16.1699 41.1362 18.4462 43.8399L26.9996 54.0002L35.5521 43.8399C37.8294 41.1362 40.2696 38.5795 42.6791 35.9931C43.8922 34.6896 44.9462 33.2354 45.8065 31.6592L45.8102 31.6555H45.8094Z",
    fill: "#00BEBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.827 21.4145C42.827 30.1559 35.7409 37.242 26.9994 37.242C18.258 37.242 11.1719 30.1559 11.1719 21.4145C11.1719 12.673 18.258 5.58691 26.9994 5.58691C35.7409 5.58691 42.827 12.6729 42.827 21.4145Z",
    fill: "#FDF8F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9998 20.4836C26.9998 16.456 28.9754 12.8976 32.0013 10.6975C31.0052 10.4061 29.953 10.2422 28.8618 10.2422C22.6919 10.2422 17.6895 15.2447 17.6895 21.4146C17.6895 27.5845 22.6919 32.587 28.8618 32.587C30.6671 32.587 32.3681 32.1484 33.8773 31.3878C29.8124 29.4364 26.9998 25.2942 26.9998 20.4836Z",
    fill: "#FFAC00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_697"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.af38f4a0fa68be71923b4fbb21ce07b0.svg";
export { ForwardRef as ReactComponent };